import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { parse } from 'date-fns/parse';
import { Flex } from '@components/layout/Grid';
import { Trans } from '@lingui/react';

const Time = styled.span`
  color: #243240;
  font-size: 38px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
`;

const Label = styled.span`
  color: #243240;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;

const Separator = styled(Time)`
  margin: 0 10px;
`;

export const WaitlistCountdown = ({ waitEndDate }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const startDate = parse(waitEndDate, 'yyyy-MM-dd', new Date());
  let timeLeft = startDate.getTime() - now;

  //
  let days, hours, minutes, seconds;

  // days
  days = Math.floor(timeLeft / (24 * 60 * 60 * 1000));
  timeLeft = timeLeft % (24 * 60 * 60 * 1000);
  // hours
  hours = Math.floor(timeLeft / (60 * 60 * 1000));
  timeLeft = timeLeft % (60 * 60 * 1000);
  // minutes
  minutes = Math.floor(timeLeft / (60 * 1000));
  timeLeft = timeLeft % (60 * 1000);
  // seconds
  seconds = Math.floor(timeLeft / 1000);

  return (
    <Flex mb={20}>
      <Flex flexDirection="column" alignItems="center">
        <Time>{String(days).padStart(2, '0')}</Time>
        <Label>
          <Trans id="metadata._days" />
        </Label>
      </Flex>
      <Separator>:</Separator>
      <Flex flexDirection="column" alignItems="center">
        <Time>{String(hours).padStart(2, '0')}</Time>
        <Label>
          <Trans id="metadata.hours" />
        </Label>
      </Flex>
      <Separator>:</Separator>
      <Flex flexDirection="column" alignItems="center">
        <Time>{String(minutes).padStart(2, '0')}</Time>
        <Label>
          <Trans id="metadata.minutes" />
        </Label>
      </Flex>
      <Separator>:</Separator>
      <Flex flexDirection="column" alignItems="center">
        <Time>{String(seconds).padStart(2, '0')}</Time>
        <Label>
          <Trans id="metadata.seconds" />
        </Label>
      </Flex>
    </Flex>
  );
};
